export enum CONTROLLER_CATALOG_ITEM_TYPES {
  MANUFACTURER = "MANUFACTURER",
  MODEL = "MODEL",
}

export type ControllerCatalogItemType = `${CONTROLLER_CATALOG_ITEM_TYPES}`;
